const CheckPolicyIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="24" fill="#F4EFED" />
    <mask
      id="mask0_4219_1298"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="12"
      y="12"
      width="24"
      height="24"
    >
      <rect x="12" y="12" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_4219_1298)">
      <path
        d="M22.9502 28.2039L28.2539 22.9002L27.1847 21.8309L22.9502 26.0657L20.8157 23.9309L19.7464 25.0002L22.9502 28.2039ZM24.0002 33.5002C22.8207 33.5002 21.7156 33.2771 20.6849 32.8309C19.6541 32.3848 18.7553 31.7783 17.9887 31.0117C17.222 30.245 16.6156 29.3463 16.1694 28.3154C15.7233 27.2848 15.5002 26.1797 15.5002 25.0002C15.5002 23.8207 15.7233 22.7156 16.1694 21.6849C16.6156 20.6541 17.222 19.7553 17.9887 18.9887C18.7553 18.222 19.6541 17.6156 20.6849 17.1694C21.7156 16.7233 22.8207 16.5002 24.0002 16.5002C25.1797 16.5002 26.2848 16.7233 27.3154 17.1694C28.3463 17.6156 29.245 18.222 30.0117 18.9887C30.7783 19.7553 31.3848 20.6541 31.8309 21.6849C32.2771 22.7156 32.5002 23.8207 32.5002 25.0002C32.5002 26.1797 32.2771 27.2848 31.8309 28.3154C31.3848 29.3463 30.7783 30.245 30.0117 31.0117C29.245 31.7783 28.3463 32.3848 27.3154 32.8309C26.2848 33.2771 25.1797 33.5002 24.0002 33.5002ZM17.7539 14.8887L18.8079 15.9424L14.9424 19.8079L13.8887 18.7539L17.7539 14.8887ZM30.2464 14.8887L34.1117 18.7539L33.0579 19.8079L29.1924 15.9424L30.2464 14.8887ZM24.0002 32.0002C25.9438 32.0002 27.5964 31.3194 28.9579 29.9579C30.3194 28.5964 31.0002 26.9438 31.0002 25.0002C31.0002 23.0565 30.3194 21.4039 28.9579 20.0424C27.5964 18.6809 25.9438 18.0002 24.0002 18.0002C22.0565 18.0002 20.4039 18.6809 19.0424 20.0424C17.6809 21.4039 17.0002 23.0565 17.0002 25.0002C17.0002 26.9438 17.6809 28.5964 19.0424 29.9579C20.4039 31.3194 22.0565 32.0002 24.0002 32.0002Z"
        fill="#0D0D0D"
      />
    </g>
  </svg>
);

export default CheckPolicyIcon;
